import { render, staticRenderFns } from "./flash-message.vue?vue&type=template&id=332b7f33"
import script from "./flash-message.vue?vue&type=script&lang=js"
export * from "./flash-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports